module.exports = __webpack_public_path__ + "static/media/9315055 Canada Corp.  - Notice of Proposal for Compliance Order - April 11, 2024.d4799855.pdf";